import * as React from "react";
import { NotFoundPlaceholder } from "Components/General/NotFoundPlaceholder";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores/ProjectsStore";
import { Loader } from "Components/General/Loader";

interface PreviewProps extends WithTranslation {
  fileId: number;
  hasPreview: boolean;
}

export const Preview = withTranslation(I18N_NS.PROJECT)(({ t, fileId, hasPreview }: PreviewProps) => {
  const [previewSrc, setPreviewSrc] = React.useState(null);

  const fetchPreview = async () => {
    try {
      const preview = await API.getBlob(API_URL.FILES.getFilePreview(projectsDataStore.projectId, fileId));
      const src = preview.size > 0 ? window.URL.createObjectURL(preview) : "";
      setPreviewSrc(src);
    } catch (error) {
      console.warn("Error during setting of preview image.");
      throw error;
    }
  };

  React.useEffect(() => {
    if (!hasPreview) {
      setPreviewSrc("");
    } else {
      fetchPreview();
    }
  }, [fileId, hasPreview]);

  if (previewSrc === null) {
    return <Loader />;
  }

  if (!hasPreview || previewSrc === "") {
    return <NotFoundPlaceholder icon={"image"} text={t("No preview available")} />;
  }

  return <img src={previewSrc} alt="Preview" className="img-fluid" />;
});
